import { IoCameraOutline, IoPrint, IoSearch } from "react-icons/io5"
import { Template } from "../../Components/Template/template"
import {
    AlertType, Grupo, Produto, classBorderLabelDark, classBt, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo, classInput,
    classInputDark, classLabel, classLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul
} from "../../Utils/Types"
import { TbReport } from "react-icons/tb"
import { useEffect, useState } from "react"
import moment from "moment"
import { VendasService } from "./vendasService"
import { ProdutoService } from "../Products/ProdutoService"
import { GridResumoPorGrupo } from "../../Components/GridProducts/GridRelatorioPorGrupo"
import { GridResumoPorProduto } from "../../Components/GridProducts/GridRelatorioPorProduto"
import { ReportResumoPorGrupoPDF } from "./pdf/report-resumo-por-grupo"
import { ReportResumoPorProdutoPDF } from "./pdf/report-resumo-por-produto"
import { AiOutlineClear } from "react-icons/ai"
import { GrupoService } from "../Grupo/GrupoService"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"

export const RelatorioVendasItensCliente = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(30, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK --------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO ----------------------------------------------------
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [filtro, setFiltro] = useState('Produto')
    const [relatorio, setRelatorio] = useState<any[]>([])

    // ---------- ATRIBUTOS GRUPO -----------------------------------------------------
    const [gruposList, setGruposList] = useState<Grupo[]>([])
    const [idGrupo, setIdGrupo] = useState(0)
    const [descGrupo, setDescGrupo] = useState("")
    const [linhaSelecionadaGrupo, setLinhaSelecionadaGrupo] = useState<number>(-1)
    //const [grupos, setGrupos] = useState<Grupo[]>([])
    //const [descGrupoCopy, setDescGrupoCopy] = useState("")

    // ---------- ATRIBUTOS PRODUTO ----------------------------------------------------
    const [produtosList, setProdutosList] = useState<Produto[]>([])
    const [idProd, setIdProd] = useState(0)
    const [descProd, setDescProd] = useState("")
    const [linhaSelecionadaProd, setLinhaSelecionadaProd] = useState<number>(-1)
    //const [produtos, setProdutos] = useState<Produto[]>([])
    //const [descProdCopy, setDescProdCopy] = useState("")

    // ---------- ATRIBUTOS LOADING -----------------------------------------------------
    const [loadingPesq, setLoadingPesq] = useState(false)


    // ------------------------------------------------------------------ INPUTS -----------------------------------------------------------------------
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeFiltro = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldMap: { [key: string]: string } = {
            'Grupo': 'Grupo',
            'Produto': 'Produto',
        }

        const selectedField = fieldMap[e.target.value]

        if (relatorio.length > 0) {
            setRelatorio([])
        }

        if (selectedField) {
            setFiltro(selectedField)

        }
    }

    const handleChangeDescProd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescProd(e.target.value)
        setProdutosList([])
        setIdProd(0)
        //setDescProdCopy('')
        setLinhaSelecionadaProd(-1)
    }

    const handleChangeDescGrupo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescGrupo(e.target.value)
        setGruposList([])
        setIdGrupo(0)
        //setDescGrupoCopy('')
        setLinhaSelecionadaGrupo(-1)
    }


    // ------------------------------------------------------------------ FUNÇOES DE API -----------------------------------------------------------------------------
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setRelatorio([])

        try {

            if (filtro === 'Produto') {

                const resp = await VendasService.VendasProdutoCliente(datai, dataf, idProd)

                if (resp.error) {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(resp.msg || ``)

                } else {
                    setRelatorio(resp.data || [])
                }

            } else {

                const resp = await VendasService.ResumoVendasItens(datai, dataf, idGrupo)

                if (resp.error) {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(resp.msg || ``)

                } else {
                    setRelatorio(resp.data || [])
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os dados`)

        } finally {

            setLoading(false)

            const timer = setTimeout(() => {
                inputFocus()
                clearTimeout(timer)
            }, 0)
        }
    }


    // ------------------------------------------------------------------- FILTROS -----------------------------------------------------------------------------------
    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroResumoVenda") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsResumoVenda") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[440px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[440px]")) {

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 100)

            } else {

                menuInputs.classList.add("invisible")

                setProdutosList([])
                setGruposList([])

            }

            event.currentTarget.blur()
        }
    }

    const handleLimparFiltros = () => {

        setDatai(dateI)
        setDataf(dateF)
        setFiltro('Produto')
        setRelatorio([])
        setDescGrupo("")
        setDescProd("")
        //setDescGrupoCopy("")
        //setDescProdCopy("")
        setIdGrupo(0)
        setIdProd(0)
        setLinhaSelecionadaProd(-1)
        setLinhaSelecionadaGrupo(-1)
    }

    const fecharLista = () => {

        if (filtro === 'Grupo') {

            setGruposList([])
            //setIdGrupo(0)
            //setDescGrupoCopy('')
            setLinhaSelecionadaGrupo(-1)

        } else if (filtro === 'Produto') {

            setProdutosList([])
            //setIdProd(0)
            //setDescProdCopy('')
            setLinhaSelecionadaProd(-1)
        }

    }

    // -------- FILTROS PRODUTOS -----------------------------------------
    const produtosFilter = async () => {

        setLoadingPesq(true)
        setVisible(false)
        setProdutosList([])

        try {

            const relatorio = {
                status: 'S' 
            }

            const produtos = await ProdutoService.Filter('descricao', descProd, 'start', relatorio)
            setProdutosList(produtos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao buscar os produtos`)

        } finally {

            setLoadingPesq(false)
            const timer = setTimeout(() => {

                const inputElement = document.getElementById("pesquisaProd")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)

        }
    }

    const handleSetProdClick = (item: any, index: number) => {
        setIdProd(item.id)
        setDescProd(item.descricao)

        //setDescProdCopy(item.descricao)
        setProdutosList([])
        setLinhaSelecionadaProd(-1)
    }

    const handleSetProdMove = (item: any, index: number) => {
        setIdProd(item.id)
        //setDescProdCopy(item.descricao)
        setDescProd(item.descricao)
        setLinhaSelecionadaProd(index)
    }

    /*
    useEffect(() => {
    
        setProdutosList([])
    
        if (descProdCopy === '') {
    
            const delayDebounceFn = setTimeout(() => {
    
                if (descProd && descProd.length > 0) {
    
                    produtosFilter()  // Chama a função após 500 segundos de inatividade
                } else {
    
                    setProdutosList([])
                }
            }, 500) // 500 segundos
    
            setIdProd(0)
    
            return () => clearTimeout(delayDebounceFn)
    
        } else {
    
            setDescProdCopy("")
            setLinhaSelecionadaProd(-1)
    
        }
    
    }, [descProd])
    */

    useEffect(() => {

        const handleKeyDownProduto = (event: any) => {

            const { key } = event

            if ((key === 'ArrowUp' || key === 'ArrowDown') && filtro === 'Produto') {
                event.preventDefault()

                let nextIndex
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionadaProd === -1 || linhaSelecionadaProd === 0 ? produtosList.length - 1 : linhaSelecionadaProd - 1;
                } else {
                    nextIndex = linhaSelecionadaProd < produtosList.length - 1 ? linhaSelecionadaProd + 1 : 0;
                }

                const selectedItem = produtosList[nextIndex]

                if (selectedItem != undefined) {

                    handleSetProdMove(selectedItem, nextIndex)
                    setLinhaSelecionadaProd(Math.max(0, Math.min(nextIndex, produtosList.length - 1)))

                    // Scroll into view
                    const element = document.getElementById(`produto-grade-${nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                } else {
                    setLinhaSelecionadaProd(-1)
                    //setProdutosList([])
                }
            }

        }

        const handleKeyPressEnterProduto = async (e: any) => {

            let menuFiltro = document.getElementById("divMenuFiltroResumoVenda") as HTMLDivElement

            const inputElement = document.getElementById("pesquisaProd")

            if ((e.code === "Enter" || e.code === "NumpadEnter") && !loadingPesq && filtro === 'Produto' && menuFiltro.classList.contains("max-h-[440px]") && document.activeElement === inputElement) {

                if (produtosList.length > 0 && linhaSelecionadaProd !== -1) {

                    //setDescProd(descProdCopy)
                    setProdutosList([])
                    setLinhaSelecionadaProd(-1)

                } else {

                    produtosFilter()

                }
            }
        }


        document.addEventListener('keydown', handleKeyDownProduto)
        document.addEventListener('keydown', handleKeyPressEnterProduto)

        return () => {
            document.removeEventListener('keydown', handleKeyDownProduto)
            document.removeEventListener('keydown', handleKeyPressEnterProduto)
        }

    }, [linhaSelecionadaProd, produtosList, datai, dataf, relatorio, loading, loadingPesq, filtro, descProd])


    // -------- FILTROS GRUPOS ------------------------------------------
    const gruposFilter = async () => {

        setLoadingPesq(true)
        setVisible(false)
        setGruposList([])

        try {

            const grupos = await GrupoService.Filter('descricao', 'start', descGrupo)
            setGruposList(grupos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao buscar os grupos`)

        } finally {
            setLoadingPesq(false)

            const timer = setTimeout(() => {
                const inputElement = document.getElementById("pesquisaGrupo")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleSetGrupoClick = (item: any, index: number) => {
        setIdGrupo(item.id)
        setDescGrupo(item.description)
        //setDescGrupoCopy(item.description)
        setGruposList([])
        setLinhaSelecionadaGrupo(-1)
    }

    const handleSetGrupoMove = (item: any, index: number) => {
        setIdGrupo(item.id)
        //setDescGrupoCopy(item.description)
        setDescGrupo(item.description)
        setLinhaSelecionadaGrupo(index)
    }

    /*
    useEffect(() => {
    
        setGruposList([])
    
        if (descGrupoCopy === '') {
    
            const delayDebounceFn = setTimeout(() => {
    
                if (descGrupo && descGrupo.length > 0) {
    
                    gruposFilter()  // Chama a função após 500 segundos de inatividade
                } else {
    
                    setGruposList([])
                }
            }, 500) // 500 segundos
    
            setIdGrupo(0)
    
            return () => clearTimeout(delayDebounceFn)
    
        } else {
    
            setDescGrupoCopy("")
            setLinhaSelecionadaGrupo(-1)
        }
    
    }, [descGrupo])
    */

    useEffect(() => {

        const handleKeyDownGrupo = (event: any) => {

            const { key } = event

            if ((key === 'ArrowUp' || key === 'ArrowDown') && filtro === 'Grupo') {
                event.preventDefault()

                let nextIndex
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionadaGrupo === -1 || linhaSelecionadaGrupo === 0 ? gruposList.length - 1 : linhaSelecionadaGrupo - 1
                } else {
                    nextIndex = linhaSelecionadaGrupo < gruposList.length - 1 ? linhaSelecionadaGrupo + 1 : 0
                }

                const selectedItem = gruposList[nextIndex]

                if (selectedItem != undefined) {

                    handleSetGrupoMove(selectedItem, nextIndex)
                    setLinhaSelecionadaGrupo(Math.max(0, Math.min(nextIndex, gruposList.length - 1)))

                    // Scroll into view
                    const element = document.getElementById(`grupo-grade-${nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                } else {
                    setLinhaSelecionadaGrupo(-1)
                    setGruposList([])
                }
            }

        }

        const handleKeyPressEnterGrupo = async (e: any) => {

            let menuFiltro = document.getElementById("divMenuFiltroResumoVenda") as HTMLDivElement

            const inputElement = document.getElementById("pesquisaGrupo")

            if ((e.code === "Enter" || e.code === "NumpadEnter") && !loadingPesq && filtro === 'Grupo' && menuFiltro.classList.contains("max-h-[440px]") && document.activeElement === inputElement) {

                if (gruposList.length > 0 && linhaSelecionadaGrupo !== -1) {

                    //setDescGrupo(descGrupoCopy)
                    setGruposList([])
                    setLinhaSelecionadaGrupo(-1)

                } else {
                    gruposFilter()
                }
            }
        }

        document.addEventListener('keydown', handleKeyDownGrupo)
        document.addEventListener('keydown', handleKeyPressEnterGrupo)

        return () => {
            document.removeEventListener('keydown', handleKeyDownGrupo)
            document.removeEventListener('keydown', handleKeyPressEnterGrupo)
        }

    }, [linhaSelecionadaGrupo, gruposList, datai, dataf, relatorio, loading, loadingPesq, filtro, descGrupo])

    const inputFocus = () => {
        const inputElement = document.getElementById("data-inicial")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------- PDF ----------------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async () => {

        setVisible(false)

        if (filtro === 'Grupo') {

            try {
                const header = [
                    { text: 'Descrição de Produto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Descrição de Grupo', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Quantidade de Itens', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Valor Líquido', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                ]

                const pdf = new ReportResumoPorGrupoPDF(relatorio, header, datai, dataf)
                pdf.GerarPDF(relatorio)


            } catch (error) {
                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)

            } finally {
                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 0)
            }

        } else {

            try {
                const header = [
                    { text: 'Descrição de Produto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Nome Cliente', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Quantidade de Itens', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                    { text: 'Valor Líquido', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },

                ]

                const pdf = new ReportResumoPorProdutoPDF(relatorio, header, datai, dataf)
                pdf.GerarPDF(relatorio)


            } catch (error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)

            } finally {
                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 0)
            }
        }
    }

    /*
    //------------------------------------------------------------- EFFECT E ATRIBUTOS ----------------------------------------------------------------------------------------------//
    const getGrupos = async () => {
    
        const attributes = await ProdutoService.GetAttributes()
    
        if (attributes) {
            setGrupos([...attributes.grupos])
            setGruposList([...attributes.grupos])
        }
    
    }
    
    const getProdutos = async () => {
    
        const attributes = await ProdutoService.ProdutoList()
    
        if (attributes) {
            setProdutos(attributes || [])
            setProdutosList(attributes || [])
        }
    
    }
    
    useEffect(() => {
        //getGrupos()
        //getProdutos()
    }, [])
    
    
    // ------------------------------------------------------------ GRUPO --------------------------------------------------------------------------------------------//
    const handleClearGrupoSelecionada = async () => {
        const newGrupoList = [...grupos || []]
        setGruposList(newGrupoList)
        setIdGrupo(0)
    
        setVisibleSearchBoxGrupo(false)
    }
    
    const handleFilterGruposClick = async (description: string) => {
    
        if (description === "") {
    
            const newGrupoList = [...grupos || []]
            setGruposList(newGrupoList || [])
    
        } else {
    
            const newGrupoList = [...grupos || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setGruposList(newGrupoList || [])
        }
    
    }
    
    const handleGruposSelectClick = (v: Grupo) => {
    
        if (v) {
            const newGrupoList = [...grupos || []]
            setGruposList(newGrupoList)
            setIdGrupo(v.id)
        }
    
        setVisibleSearchBoxGrupo(false)
    
    }
    
    const clickSearchBoxGrupo = () => {
    
        // Verifica se o visibleSearchBoxGrupo está visível.
        if (visibleSearchBoxGrupo) {
            // Caso esteja visível, fecha o visibleSearchBoxGrupo.
            setVisibleSearchBoxGrupo(false)
        } else {
            // Caso contrário, abre o visibleSearchBoxGrupo.
            setVisibleSearchBoxGrupo(true)
        }
    
    }
    
    // ------------------------------------------------------------ PRODUTO --------------------------------------------------------------------------------------------//
    const handleClearProdutoSelecionado = async () => {
        const newProdutoList = [...produtos || []]
        setProdutosList(newProdutoList)
        setIdProd(0)
    
        setVisibleSearchBoxProduto(false)
    }
    
    const handleFilterProdutoClick = async (description: string) => {
    
        if (description === "") {
    
            const newProdutoList = [...produtos || []]
            setProdutosList(newProdutoList || [])
    
        } else {
    
            const newProdutoList = [...produtos || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setProdutosList(newProdutoList || [])
        }
    
    }
    
    const handleProdutoSelectClick = (v: Produto) => {
    
        if (v) {
            const newProdutoList = [...produtos || []]
            setProdutosList(newProdutoList)
            setIdProd(v.id)
        }
    
        setVisibleSearchBoxProduto(false)
    }
    
    const clickSearchBoxProduto = () => {
    
        // Verifica se o visibleSearchBoxProduto está visível.
        if (visibleSearchBoxProduto) {
            // Caso esteja visível, fecha o visibleSearchBoxProduto.
            setVisibleSearchBoxProduto(false)
        } else {
            // Caso contrário, abre o visibleSearchBoxProduto.
            setVisibleSearchBoxProduto(true)
        }
    
    }
    
    <SearchBox
        disabled={false}
        label={filtro === 'Produto' ? `Produtos` : `Grupos`}
        dataList={filtro === 'Produto' ? produtosList : gruposList}
        setDataClick={filtro === 'Produto' ? handleProdutoSelectClick : handleGruposSelectClick}
        clearDataClick={filtro === 'Produto' ? handleClearProdutoSelecionado : handleClearGrupoSelecionada}
        filterDataClick={filtro === 'Produto' ? handleFilterProdutoClick : handleFilterGruposClick}
        idRegistro={filtro === 'Produto' ? idProd || undefined : idGrupo || undefined}
        clicado={filtro === 'Produto' ? clickSearchBoxProduto : clickSearchBoxGrupo}
        componentId={filtro === 'Produto' ? 'produto' : 'grupo'}
    />
    */

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-8 flex flex-row items-center`}>
                            <TbReport className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Resumos de Venda</span>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2`}>

                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>

                        </div>

                        <div className={`relative col-span-6 sm:col-span-2`}>
                            <button tabIndex={-1} className={`${classBt} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(relatorio.length > 0)} onClick={handleGerarPDFClick}>
                                <IoPrint size="20px" className={`hidden md:block mr-2`} />
                                Imprimir
                            </button>
                        </div>

                    </div>

                    <div id='divInputsResumoVenda' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroResumoVenda' className={`relative max-h-[0px] h-[440px] sm:h-[220px] xl:h-[160px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <input id='data-inicial' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={fecharLista} onChange={handleChangeDtInicio} />
                                <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Período Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <input id='data-final' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={fecharLista} onChange={handleChangeDtFim} />
                                <label htmlFor="data-final" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Data Período Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <select id="filter" className={`${classInput} ${classInputDark} `} value={filtro} onFocus={fecharLista} onChange={handleChangeFiltro}>
                                    <option value="Produto">Produto</option>
                                    <option value="Grupo">Grupo</option>
                                </select>
                                <label htmlFor="filter" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Filtrar por</label>
                            </div>

                            <div className={`relative col-span-12 xl:col-span-6 mt-2`}>

                                {filtro === 'Produto' ?

                                    <div className={`flex w-full h-[45px] items-center`}>

                                        <div className={`flex items-center justify-center`}>
                                            <button className={`absolute h-[43px] w-10 right-[1px] z-10 border bg-slate-300 hover:bg-slate-600 transition-colors duration-300 border-slate-400 border-y-0 border-r-0 dark:bg-slate-500 dark:hover:bg-slate-800 dark:border-slate-700 dark:focus:border-slate-400" rounded-r-md `} onClick={produtosFilter}>
                                                <div className={`w-full h-full flex justify-center items-center text-slate-700 hover:text-slate-300 dark:text-slate-100`}>
                                                    {!loadingPesq &&
                                                        <IoSearch className={`h-[18px] w-[18px]`} />
                                                    }
                                                    {loadingPesq &&

                                                        <div className={`z-10 absolute mx-2 inline-block h-[18px] w-[18px] animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                        </div>
                                                    }
                                                </div>
                                            </button>
                                        </div>

                                        <div className={`relative w-full`}>

                                            <input id='pesquisaProd' className={`${classInput} ${classInputDark} w-full pr-14`} placeholder='Digite o nome do produto e pressione Enter ou clique na lupa para buscar o produto' value={descProd} autoComplete='off' onChange={handleChangeDescProd} />
                                            <label htmlFor="pesquisaProd" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Produto</label>

                                            {produtosList.length > 0 &&

                                                <div className={`absolute z-20 w-full min-h-[100px] max-h-[600px] overflow-y-auto bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-800 rounded-md`}>

                                                    <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                                        <ul id='elementos' className={`w-full`}>

                                                            {produtosList.map((item, index) => {
                                                                return (

                                                                    <li key={item.id} id={`produto-grade-${index}`} onClick={() => handleSetProdClick(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionadaProd ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                                        <div className={`w-full flex flex-row h-[48px] font-mono border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>

                                                                            <div className={`flex items-center w-[10%] break-all `}>
                                                                                {item.urlImage &&
                                                                                    <img alt='' className={`w-12 h-10 mx-1 bg-white`} src={item.urlImage} />
                                                                                }
                                                                                {!item.urlImage &&
                                                                                    <IoCameraOutline className={`w-12 h-10 mx-1 text-slate-300`} />
                                                                                }
                                                                            </div>

                                                                            <div className={`flex items-center text-sm w-[70%] break-all `}>
                                                                                <span className={`px-2`}>{item.descricao.trim()}</span>
                                                                            </div>

                                                                            <div className={`flex items-center justify-end text-sm w-[20%] `}>
                                                                                <span className={`px-2`}>{`Estoque Físico: ${item.estoque_fisico}`}</span>
                                                                            </div>

                                                                        </div>

                                                                    </li>
                                                                )
                                                            })
                                                            }

                                                        </ul>

                                                    </div>

                                                </div>
                                            }
                                        </div>

                                    </div>
                                    :
                                    <div className={`flex w-full h-[45px] items-center`}>

                                        <div className={`flex items-center justify-center`}>
                                            <button className={`absolute h-[43px] w-10 right-[1px] z-10 border bg-slate-300 hover:bg-slate-600 transition-colors duration-300 border-slate-400 border-y-0 border-r-0 dark:bg-slate-500 dark:hover:bg-slate-800 dark:border-slate-700 dark:focus:border-slate-400" rounded-r-md `} onClick={gruposFilter}>
                                                <div className={`w-full h-full flex justify-center items-center text-slate-700 hover:text-slate-300 dark:text-slate-100`}>
                                                    {!loadingPesq &&
                                                        <IoSearch className={`h-[18px] w-[18px]`} />
                                                    }
                                                    {loadingPesq &&

                                                        <div className={`z-10 absolute mx-2 inline-block h-[18px] w-[18px] animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                        </div>
                                                    }
                                                </div>
                                            </button>
                                        </div>

                                        <div className={`relative w-full`}>

                                            <input id='pesquisaGrupo' className={`${classInput} ${classInputDark} w-full`} placeholder='Digite o nome do grupo e pressione Enter ou clique na lupa para buscar o grupo' value={descGrupo} autoComplete='off' onChange={handleChangeDescGrupo} />
                                            <label htmlFor="pesquisaGrupo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Grupo</label>

                                            {gruposList.length > 0 &&

                                                <div className={`absolute z-20 w-full min-h-[100px] max-h-[600px] overflow-y-auto bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-800 rounded-md`}>

                                                    <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                                        <ul id='elementos' className={`w-full`}>

                                                            {gruposList.map((item, index) => {
                                                                return (

                                                                    <li key={item.id} id={`grupo-grade-${index}`} onClick={() => handleSetGrupoClick(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionadaGrupo ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                                        <div className={`w-full flex flex-row h-[48px] font-mono border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>

                                                                            <div className={`flex items-center text-sm w-[70%] break-all `}>
                                                                                <span className={`px-2`}>{item.description}</span>
                                                                            </div>

                                                                        </div>

                                                                    </li>
                                                                )
                                                            })
                                                            }

                                                        </ul>

                                                    </div>

                                                </div>
                                            }
                                        </div>

                                    </div>
                                }

                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`hidden md:block mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        {filtro === 'Produto' && <GridResumoPorProduto resumoPorProduto={relatorio} />}

                        {filtro === 'Grupo' && <GridResumoPorGrupo resumoPorGrupo={relatorio} />}

                    </div>

                </div>

            </div>

        </Template>
    )
}